import React, { useState } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { css } from '@emotion/react';
import { ClipLoader } from 'react-spinners';

const override = css`
  display: block;
  margin: 0 auto;
`;

const Register = ({ setIsAuthenticated }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleRegister = async (e) => {
    e.preventDefault();
    setLoading(true);
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 10000); // 10-second timeout
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}admin/register`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password, userType: 'admin' }),
        signal: controller.signal,
      });
      const data = await response.json();
      console.log('Response:', response, 'Data:', data); 
      if (response.ok) {
        toast.success('Registration successful! Please login.');
        // Optionally redirect or set authentication state
        // setIsAuthenticated(true); // Uncomment if needed
      } else {
        toast.error(data.message || 'Registration failed');
      }
    } catch (error) {
      console.error('Error during registration:', error); // Debug log
      if (error.name === 'AbortError') {
        toast.error('Request timed out. Please try again.');
      } else {
        toast.error('An error occurred. Check the console for details.');
      }
    } finally {
      clearTimeout(timeoutId);
      setLoading(false); // Ensure loading stops
    }
  };

  return (
    <div className="flex items-center justify-center h-screen bg-gray-100">
      <div className="w-full max-w-md p-6 bg-white rounded-lg shadow-lg">
        <h2 className="text-2xl font-bold mb-4 text-center">Admin Register</h2>
        <form onSubmit={handleRegister} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
              required
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
              required
            />
          </div>
          <button
            type="submit"
            className="w-full bg-green-500 text-white p-2 rounded-md hover:bg-green-600"
            disabled={loading}
          >
            {loading ? <ClipLoader color="#ffffff" css={override} size={20} /> : 'Register'}
          </button>
        </form>
        <ToastContainer />
      </div>
    </div>
  );
};

export default Register;